import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="error-boundary">
          <div className="bg-white border border-border rounded-2xl p-8 max-w-md w-full text-center shadow-lg">
            <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8 text-destructive" />
            </div>
            <h1 className="font-display text-2xl mb-2">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-5">
              We hit an unexpected issue. Refresh the page or go back home.
            </p>
            <div className="flex gap-2 justify-center">
              <Button onClick={() => window.location.reload()} className="bg-saffron hover:bg-saffron-dark text-white" data-testid="error-reload">Reload</Button>
              <Link to="/"><Button variant="outline" data-testid="error-home">Go home</Button></Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
